export const LOGO_SIZE_SMALL = 24;
export const LOGO_SIZE_MEDIUM = 32;
export const LOGO_SIZE_LARGE = 40;
export const LOGO_SIZE_EXTRA_LARGE = 48;
export const LOGO_SIZE_DEFAULT = LOGO_SIZE_MEDIUM;
